module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/6-10e6d76ffb8c909e90f94ef1fb057e1d.jpg";